// extracted by mini-css-extract-plugin
export default {"container":"subscribers_container__C3uCo"};